// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - TOGGLE BUTTON ||============================== //

export default function ToggleButton(theme: Theme) {
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          fontWeight: 100,
          
          color: theme.palette.text.secondary,
          '&.Mui-disabled': {
            borderColor: theme.palette.divider,
            color: theme.palette.text.disabled
          },
          '&.Mui-selected': {
            fontWeight: 600,
          }
        },
        sizeSmall: {
          padding: '4px 8px',
          fontSize: theme.typography.body2.fontSize
        },
        sizeMicro: {
          padding: '2px 6px',
          fontSize: '0.65rem !important',
          lineHeight: 1.4
        },
      }
    }
  };
}
